import axios from 'axios';   
import EndPoints from '../constants/endPoints';
import { OfferIssuerResource } from '../models/resource/offerIssuerResource';
import { OfferIssuerRequest } from '../models/request/offerIssuerRequest';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ALMOWAZI_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const authToken = localStorage.getItem('token');
  if (authToken) {
    const tokenData = JSON.parse(atob(authToken.split('.')[1]));
    const tokenExp = tokenData.exp * 1000; 
    const currentTime = new Date().getTime(); 

    if (tokenExp < currentTime) { 
      localStorage.removeItem('token'); 
      localStorage.setItem('expired','true'); 
      window.location.href = '/Signin';
    } else {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    return Promise.reject(error);
  }
);
 
const getOfferIssuer = async (): Promise<any> => {
    try { 
        const response = await axiosInstance.get(EndPoints.OfferIssuer.GetAll);  
        return response;
    } catch (error) { 
        throw new Error('Failed to get offer issuer');
    }
};  

const getOfferIssuerById = async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.get(EndPoints.OfferIssuer.GetById, {
      params: { id }
    });
    return response;
  } catch (error) {
    console.error('Failed to get OfferIssuer:', error);
    throw new Error('Failed to get OfferIssuer');
  }
};  


const saveOfferIssuer = async (data: OfferIssuerResource): Promise<any> => {
  try {
    const response = await axiosInstance.post(EndPoints.OfferIssuer.Save, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error) {
    console.error('Failed to save offerIssuer:', error);
    throw new Error('Failed to save offerIssuer');
  }
};  

const deleteOfferIssuer = async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.delete(EndPoints.OfferIssuer.Delete, { params: { id } });
    return response;
  } catch (error) {
    console.error('Failed to delete OfferIssuer:', error);
    throw new Error('Failed to delete OfferIssuer');
  }
};
 

const getOfferIssuerList = async (data: OfferIssuerRequest): Promise<any> => {
  try { 
    const response = await axiosInstance.get(EndPoints.OfferIssuer.GetPageList, { params: data });
    return response;
  } catch (error) {
    console.error('Failed to get offerIssuer:', error);
    throw new Error('Failed to get offerIssuer');
  }
}; 


export const offerIssuerService = {
    getOfferIssuer, 
    getOfferIssuerById, 
    saveOfferIssuer, 
    deleteOfferIssuer, 
    getOfferIssuerList, 
};
